export default {
  global: {
    colors: {
      brand: '#1B2430',
      focus: "#7159c1"
    },
    font: {
      family: 'Roboto',
      size: '18px',
      height: '20px',
    },
  },
};
